import FormNuevoSectorComponent from "../components/formsSector/FormNuevoSector";

const NuevoSectorPage = () => {
    return(
        <>
            <FormNuevoSectorComponent/>
        </>
    );
}
export default NuevoSectorPage;